// take all console method calls and fix the parameters if they are not strings
// this is to avoid issues with some browsers that do not support console method calls with non-string parameters

// do this only if cefsharp is detected
var isCefSharp =
  (typeof window !== "undefined" && window && window.cefSharp) ||
  (typeof window !== "undefined" && window && window.CefSharp) ||
  (typeof navigator === "object" && navigator && navigator.userAgent && navigator.userAgent.indexOf("CefSharp") >= 0) ||
  (typeof navigator === "object" && navigator && navigator.userAgent && navigator.userAgent.indexOf("Electron") >= 0);
if (isCefSharp) {
  console.log("CefSharp detected, patching console methods to fix non-string parameters");

  const consoleMethods = ["log", "info", "warn", "error", "debug", "trace"];
  consoleMethods.forEach((method) => {
    const originalMethod = console[method];
    console[method] = function (...args) {
      try {
        const fixedArgs = args.map((arg) => {
          if (typeof arg === "string") {
            return arg;
          }

          // detect error objects and convert to string
          if (arg instanceof Error) {
            return `${arg.name}: ${arg.message}\n${arg.stack} - ${arg.toString()}`;
          }

          // for other objects, try to convert to JSON string

          try {
            return JSON.stringify(arg);
          } catch (e) {
            return String(arg);
          }
        });

        // truncate each argument to 10000
        for (let i = 0; i < fixedArgs.length; i++) {
          if (fixedArgs[i] && fixedArgs[i].length > 10000) {
            fixedArgs[i] = fixedArgs[i].substring(0, 10000) + "... [truncated]";
          }
        }

        originalMethod.apply(console, fixedArgs);
      } catch (e) {
        originalMethod.apply(console, ["Error in console patcher", e]);
        originalMethod.apply(console, args);
      }
    };
  });
}

export {};
